/* Biohazard custom-print quote hook (2026-10-20; 2026-10-21: per-form data-bhq-hook / data-bhq-ext / data-bhq-files-required / data-bhq-files-note for vendor + tax forms).
 * On submit of a Shopify contact form that contains [data-bhq-ts] (snippets/bh-quote-fields.liquid):
 *  1. posts the fields + up to 3 artwork files (multipart/form-data) to the n8n webhook -> Pipedrive lead for Andrew,
 *  2. waits for that upload to finish or fail (short timeout),
 *  3. adds a "Files uploaded" line to the message, then lets the normal Shopify submit continue so the email still goes out.
 * Files are never sent to Shopify (the file input has no name attribute).
 */
(function () {
  if (window.__bhQuote) return; window.__bhQuote = true;
  var HOOK = 'https://biohazardinc.app.n8n.cloud/webhook/custom-quote-46e3466c4c98';
  var MAX_FILES = 3, MAX_BYTES = 10 * 1024 * 1024;
  var OK_EXT = ['pdf', 'png', 'jpg', 'jpeg', 'svg', 'ai', 'eps', 'psd'];
  var MAP = { 'contact[name]': 'name', 'contact[email]': 'email', 'contact[phone]': 'phone', 'contact[Phone Number]': 'phone',
    'contact[Company]': 'company', 'contact[State]': 'state', 'contact[Packaging Type]': 'packaging', 'contact[Quantity]': 'quantity',
    'contact[Product Heading]': 'product_heading', 'contact[Page URL]': 'page_url', 'contact[body]': 'message' };

  function ext(n) { var m = /\.([a-z0-9]+)$/i.exec(n || ''); return m ? m[1].toLowerCase() : ''; }
  function mb(b) { return (b / 1048576).toFixed(1) + ' MB'; }
  function isQuote(f) { return f && f.tagName === 'FORM' && f.querySelector('[data-bhq-ts]'); }

  function exts(form) { var a = form.getAttribute('data-bhq-ext'); return a ? a.toLowerCase().split(',') : OK_EXT; }
  function hookOf(form) { return form.getAttribute('data-bhq-hook') || HOOK; }
  function pickFiles(form) {
    var input = form.querySelector('[data-bhq-files]'), ok = [], bad = [], allow = exts(form);
    var files = input && input.files ? Array.prototype.slice.call(input.files) : [];
    files.forEach(function (f) {
      if (allow.indexOf(ext(f.name)) < 0) bad.push({ f: f, why: 'file type not accepted' });
      else if (f.size > MAX_BYTES) bad.push({ f: f, why: 'over 10 MB' });
      else if (ok.length >= MAX_FILES) bad.push({ f: f, why: 'more than 3 files' });
      else ok.push(f);
    });
    return { ok: ok, bad: bad };
  }

  function renderList(form) {
    var ul = form.querySelector('[data-bhq-filelist]'); if (!ul) return;
    var p = pickFiles(form); ul.innerHTML = '';
    p.ok.forEach(function (f) { var li = document.createElement('li'); li.textContent = f.name + ' (' + mb(f.size) + ')'; ul.appendChild(li); });
    p.bad.forEach(function (b) { var li = document.createElement('li'); li.className = 'bhq-bad';
      li.textContent = b.f.name + ' – not uploaded (' + b.why + '). Please email it to us after you submit.'; ul.appendChild(li); });
  }

  function syncPkg(form) {
    var h = form.querySelector('[data-bhq-pkg-value]'); if (!h) return true;
    var v = Array.prototype.slice.call(form.querySelectorAll('[data-bhq-pkg]')).filter(function (c) { return c.checked; })
      .map(function (c) { return c.value; });
    h.value = v.join(', ');
    return v.length > 0;
  }

  function init(form) {
    if (form.__bhqInit) return; form.__bhqInit = true;
    var ts = form.querySelector('[data-bhq-ts]'); if (ts) ts.value = String(Date.now());
    var u = form.querySelector('[data-bhq-url]'); if (u) u.value = location.href.split('#')[0];
    var fi = form.querySelector('[data-bhq-files]'); if (fi) fi.addEventListener('change', function () { renderList(form); var fe = form.querySelector('[data-bhq-files-error]'); if (fe && pickFiles(form).ok.length) fe.hidden = true; });
    Array.prototype.forEach.call(form.querySelectorAll('[data-bhq-pkg]'), function (c) {
      c.addEventListener('change', function () { var e = form.querySelector('[data-bhq-pkg-error]'); if (syncPkg(form) && e) e.hidden = true; });
    });
  }

  function fieldsData(form) {
    var fd = new FormData(), extra = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled || el.type === 'file') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (MAP[el.name]) fd.append(MAP[el.name], el.value);
      else if (/^contact\[(.+)\]$/.test(el.name)) extra[RegExp.$1] = el.value;
    });
    var hp = form.querySelector('[name="bh_hp"]'), ts = form.querySelector('[data-bhq-ts]');
    fd.append('hp', hp ? hp.value : ''); fd.append('ts', ts ? ts.value : '');
    fd.append('extra', JSON.stringify(extra));
    return fd;
  }

  function send(form) {
    var p = pickFiles(form), fd = fieldsData(form), total = 0;
    p.ok.forEach(function (f, i) { fd.append('file' + i, f, f.name); total += f.size; });
    p.bad.forEach(function (b) { fd.append('files_rejected', b.f.name + ' (' + b.why + ')'); });
    var hasFiles = p.ok.length > 0;
    // keepalive bodies are capped at 64 KB by browsers, so it is only used when there are no files.
    var timeoutMs = hasFiles ? Math.min(25000, 6000 + Math.ceil(total / 1048576) * 1500) : 4000;
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs);
    var opts = { method: 'POST', body: fd, keepalive: !hasFiles, mode: 'cors' }; if (ctrl) opts.signal = ctrl.signal;
    return fetch(hookOf(form), opts).then(function (r) { clearTimeout(timer); return { ok: r.ok, p: p }; })
      .catch(function () {
        clearTimeout(timer);
        // Upload failed or timed out: still create the Pipedrive lead from the fields alone.
        try { var f2 = fieldsData(form); f2.append('files_failed', p.ok.map(function (f) { return f.name; }).join(', '));
          p.bad.forEach(function (b) { f2.append('files_rejected', b.f.name + ' (' + b.why + ')'); });
          if (navigator.sendBeacon) navigator.sendBeacon(hookOf(form), f2); } catch (e) {}
        return { ok: false, p: p };
      });
  }

  function noteLine(res, form) {
    var p = res.p, lines = [], dest = (form && form.getAttribute('data-bhq-files-note')) || 'attached in Pipedrive';
    if (p.ok.length && res.ok) lines.push('Files uploaded: ' + p.ok.length + ', ' + dest + ' (' + p.ok.map(function (f) { return f.name; }).join(', ') + ')');
    if (p.ok.length && !res.ok) lines.push('Files selected but the upload did not finish: ' + p.ok.map(function (f) { return f.name; }).join(', ') + ' – please ask the customer to email them.');
    if (p.bad.length) lines.push('Files not uploaded: ' + p.bad.map(function (b) { return b.f.name + ' (' + b.why + ')'; }).join(', ') + ' – please ask the customer to email them.');
    return lines.length ? '\n\n---\n' + lines.join('\n') : '';
  }

  function continueSubmit(form, submitter) {
    form.__bhqDone = true;
    if (form.requestSubmit) { try { submitter ? form.requestSubmit(submitter) : form.requestSubmit(); return; } catch (e) {} }
    HTMLFormElement.prototype.submit.call(form);
  }

  // Capture phase on document: runs before Shopify's captcha / theme listeners on the form.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isQuote(form)) return;
    if (form.__bhqDone) { form.__bhqDone = false; return; }       // second pass -> normal Shopify submit
    init(form);
    if (!syncPkg(form)) {
      e.preventDefault(); e.stopImmediatePropagation();
      var er = form.querySelector('[data-bhq-pkg-error]'); if (er) { er.hidden = false; er.scrollIntoView({ block: 'center' }); }
      return;
    }
    if ((form.hasAttribute('data-bhq-files-required') || form.querySelector('[data-bhq-files][required]')) && pickFiles(form).ok.length === 0) {
      e.preventDefault(); e.stopImmediatePropagation();
      var fe = form.querySelector('[data-bhq-files-error]'); if (fe) { fe.hidden = false; fe.scrollIntoView({ block: 'center' }); }
      return;
    }
    var hp = form.querySelector('[name="bh_hp"]');
    if (hp && hp.value) return;                                    // bot: skip the webhook, Shopify handles it as before
    e.preventDefault(); e.stopImmediatePropagation();
    if (form.__bhqBusy) return; form.__bhqBusy = true;
    var submitter = e.submitter && e.submitter.form === form ? e.submitter : null;
    var btn = submitter || form.querySelector('[type="submit"]'), label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Sending…'; }
    send(form).then(function (res) {
      var body = form.querySelector('[name="contact[body]"]'); var line = noteLine(res, form);
      if (body && line && body.value.indexOf('\n---\nFiles') < 0) body.value += line;
    }).catch(function () {}).then(function () {
      form.__bhqBusy = false;
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      continueSubmit(form, submitter);
    });
  }, true);

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('form'), function (f) { if (isQuote(f)) init(f); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* BH floating-label fix (2026-10-20 hotfix). The theme only adds .is-filled on keyup, and on product pages theme.js
 * stops early (gallery zoom error) so it never adds it at all. Autofill/paste/programmatic values then leave the label
 * on top of the typed text. This keeps .is-filled in sync for every floating-label field on the page. */
(function () {
  if (window.__bhFloat) return; window.__bhFloat = true;
  function lab(el) { var n = el.nextElementSibling; return n && n.classList && n.classList.contains('form__floating-label'); }
  function sync(el) {
    if (!el || !el.tagName) return;
    if (el.tagName === 'SELECT') { var w = el.parentNode; if (w && w.classList && w.classList.contains('select-wrapper') && lab(w)) w.classList.toggle('is-filled', el.value !== ''); return; }
    if ((el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') && el.classList.contains('form__field') && lab(el)) el.classList.toggle('is-filled', el.value !== '');
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('input.form__field, textarea.form__field, .select-wrapper > select'), sync); }
  ['input', 'change', 'keyup', 'focusout', 'animationstart'].forEach(function (t) { document.addEventListener(t, function (e) { sync(e.target); }, true); });
  try { var s = document.createElement('style');
    s.textContent = '.form__field:-webkit-autofill+.form__floating-label{transform:translateY(-6px) scale(.8)}@keyframes bhAutofill{from{opacity:1}to{opacity:1}}.form__field:-webkit-autofill{animation:bhAutofill 1ms}';
    (document.head || document.documentElement).appendChild(s); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all); [500, 1500, 3000].forEach(function (ms) { setTimeout(all, ms); });
})();

/* Product pages in the custom-printing collection render the quote form instead of product-info, so the theme's
 * ".product-block-list__item--info .card" height sync never runs and the absolutely-positioned form column overflows
 * under the description (message box + Send button hidden). Mirror the theme: wrapper min-height = form height. */
(function () {
  function fit() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-block-list__item--info'), function (info) {
      if (info.__bhqFit || info.querySelector('.card') || !info.querySelector('form [data-bhq-ts]')) return;
      var list = info.closest('.product-block-list'), w = list && list.querySelector('.product-block-list__wrapper'), c = info.firstElementChild;
      if (!w || !c) return; info.__bhqFit = true;
      var set = function () { w.style.minHeight = c.offsetHeight + 'px'; };
      set(); if (window.ResizeObserver) new ResizeObserver(set).observe(c); window.addEventListener('load', set);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
})();
